<!-- This needs refactoring, it's confusing because we no longer need a "minimal" version anymore
Eventually this should be replaced with the score card design  -->
<template>
    <v-container fluid style="position:relative">
        <v-row class="pa-0">
            <v-col cols="12" lg="8" class="pt-0">
                <v-row wrap>
                    <v-col cols="12" class="pt-0">
                        <div class="q-display-2 inline-form-left full-width">
                            <v-alert v-if="!agent.IsAgencyOwner && agent.LeadershipLevel != 'Key Leader'" type="warning">Please note: your stats are of your personal production only. These stats do not include any downline business.</v-alert>
                            <span v-if=" agent.IsAgencyOwner">Agency Production Stats</span>
                            <span v-else>Production Stats</span>
                            <q-tooltip-details v-else>
                                <span v-if="agent.IsAgencyOwner"> These are master aggregate production stats. </span>
                                Stats updated weekly. Placed Data is updated monthly during the following month due to data availibility.
                            </q-tooltip-details>
                        </div>
                        <div>
                            <p class="body-2 full-width">Quility HQ data is synced nightly and does not provide real-time data. Please reference Opt! for the most up-to-date metrics.</p>
                        </div>
                    </v-col>
                    <v-col cols="12" class="pt-0">
                        <div class="inline-form-left">
                            <q-business-time-period-select :disabled="loading" v-model="datePeriod" label="Time Period" :allow-current="true" stateKey="stat"></q-business-time-period-select>
                        </div>
                    </v-col>
                    <v-col id="v-prod-1" cols="12" :sm="cols">
                        <q-stats-submitted-chart :agent="agent" :start-date="datePeriod.startDateFormat" :end-date="datePeriod.endDateFormat" :time-period="datePeriod.period" :goal="promotionLevelAPV"></q-stats-submitted-chart>
                        <q-stats-unique-writers-chart v-if="agent.IsAgencyOwner || agent.LeadershipLevel == 'Key Leader'" :agent="agent" :start-date="datePeriod.startDateFormat" :end-date="datePeriod.endDateFormat" :time-period="datePeriod.period" :goal="promotionLevelUW"></q-stats-unique-writers-chart>
                        <div class="stat pb-4">
                            <div v-if="agent.IsAgencyOwner">
                                <div v-if="agent.LeadershipLevel != 'Agency Owner'">
                                    <q-stats-close-ratio-chart :agent="agent" :start-date="datePeriod.startDateFormat" :end-date="datePeriod.endDateFormat" :time-period="datePeriod.period" :goal="promotionLevelAPV" stat-type="Master"></q-stats-close-ratio-chart>
                                </div>
                                <div v-else>
                                    <q-stats-close-ratio-chart :agent="agent" :start-date="datePeriod.startDateFormat" :end-date="datePeriod.endDateFormat" :time-period="datePeriod.period" :goal="promotionLevelAPV" stat-type="Baseshop"></q-stats-close-ratio-chart>
                                </div>
                            </div>
                            <div v-else-if="agent.LeadershipLevel == 'Key Leader'">
                                <q-stats-close-ratio-chart :agent="agent" :start-date="datePeriod.startDateFormat" :end-date="datePeriod.endDateFormat" :time-period="datePeriod.period" :goal="promotionLevelAPV" stat-type="Master"></q-stats-close-ratio-chart>
                            </div>
                            <div v-else>
                                <q-stats-close-ratio-chart :agent="agent" :start-date="datePeriod.startDateFormat" :end-date="datePeriod.endDateFormat" :time-period="datePeriod.period" :goal="promotionLevelAPV" stat-type="PersonalProduction"></q-stats-close-ratio-chart>
                            </div>
                            <p class="stat-label">Submitted business {{datePeriod.period}} is {{datePeriod.startDateFormat}} through {{datePeriod.endDateFormat}}. Close Ratio is 6-week rolling average from {{datePeriod.endDateFormat}}. Current stats are synced with Opt nightly.</p>
                        </div>
                    </v-col>
                    <v-col cols="12" :sm="cols" class="px-4">
                        <q-stats-placed-chart :agent="agent" :start-date="datePeriod.startDateFormat" :end-date="datePeriod.endDateFormat" :time-period="datePeriod.period" :goal="promotionLevelAPV" :stat-type="agent_stat_type"></q-stats-placed-chart>
                    </v-col>
                </v-row>
            </v-col>
            <v-col id="v-promotion-2" cols="12" lg="4" v-if="!loading">
                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title class="q-display-2">Promotion Tracker</v-list-item-title>
                        <v-list-item-subtitle><a target="_tab" href="https://hq.quility.com/api/public/document/44375/view/1614095629/130aa5d61cd4f43c6f55bbe1add8bcee">Promotion Guidelines</a></v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                <q-promotion-tracker-chart :data="stats.salesData" :placed-data="stats.placedData" :agent-contract-level="agent.ContractLevel" class="promotion-tracker"></q-promotion-tracker-chart>
            </v-col>
            <v-col id="v-monthly-3" cols="12" v-if="stats.salesData.length > 0 && !loading">
                <v-list-item one-line>
                    <v-list-item-content>
                        <v-list-item-title class="q-display-2">Monthly Sales Data
                            <q-tooltip-details>
                                <span class="q-subtitle">This stat is updated weekly.<br>Note that historical data for 'submits' will be available from May 2020 onward. Placed data is updated monthly during the following month when data is available from the carriers.</span>
                            </q-tooltip-details>
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <q-monthly-sales-chart :data="stats.salesData" :placed-data="stats.placedData" :type="agent_stat_type"></q-monthly-sales-chart>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import QuilityAPI from '@/store/API/QuilityAPI.js'
import QProgressStat from '@/components/stats/QProgressStat.vue';
import QComparisonStat from '@/components/stats/QComparisonStat.vue';
import QMonthlySalesChart from '@/components/charts/QMonthlySalesChart.vue';
import QPromotionTrackerChart from '@/components/charts/QPromotionTrackerChart.vue';
import QTooltipDetails from '@/components/utils/QTooltipDetails.vue';

import User from '@/store/Models/User'
import PromotionLevels from '@/store/PromotionLevels.json'
import QBusinessTimePeriodSelect from '@/components/utils/QBusinessTimePeriodSelect.vue';

import QStatsSubmittedChart from '@/components/charts/QStatsSubmittedChart.vue';
import QStatsCloseRatioChart from '@/components/charts/QStatsCloseRatioChart.vue';
import QStatsPlacedChart from '@/components/charts/QStatsPlacedChart.vue';
import QStatsUniqueWritersChart from '@/components/charts/QStatsUniqueWritersChart.vue';
export default {
    props: {
        'agent': {
            type: Object,
            default: function() {
                return {}
            },
        },
    },
    data: function() {
        return {
            stats: {
                "rollingCloseRatio6weeks": {},
                "rollingCloseRatioPrevious6weeks": {},
                "weeklyProduction": {},
                "weeklyProductionPrevious": {},
                "salesData": [],
                "placedData": [],
            },
            loading: false,
            datePeriod: { label: 'Current Month' },
            statType: null,
        }
    },
    mounted: function() {
        this.loadData()
    },
    computed: {
        promotionLevelAPV: function() {
            return this.promotionLevel().APV;
        },
        promotionLevelPlaced: function() {
            return this.promotionLevel().MinimumAPV;
        },
        promotionLevelUW: function() {
            return this.promotionLevel().UniqueWriters;
        },
        cols: function() {
            if (this.minimal) {
                return 12
            }
            return 6
        },
        agent_stat_type: function() {
            //PersonalProduction
            if (this.agent.IsAgencyOwner) {
                return;
            }
            if (this.agent.LeadershipLevel == 'KeyLeader') {
                return "Baseshop"
            }
            return "PersonalProduction";
        }
    },
    methods: {
        promotionLevel: function() {

            //ensure that contract level is set
            // before performing search
            const contractLevel = this.agent.ContractLevel ? this.agent.ContractLevel : this.agent.Agent.ContractLevel

            for (var i = 0; i < PromotionLevels.length; i++) {
                if (contractLevel == PromotionLevels[i].CommissionLevel) {
                    return PromotionLevels[i]
                }
            }
            return {};
        },
        loadData: function() {
            if (typeof this.agent == 'undefined') {
                return;
            }
            var g = this
            this.loading = true;

            var params = {}; //you can add "type" to get a certain type of stats - baseshop or total agency or production

            var params = {
                type: this.agent_stat_type,
                startDate: null,
                endDate: null,
                timePeriod: 'month'
            };

            QuilityAPI.getStatRangeCombined(this.agent.AgentCode, params).then(function(json) {
                g.loading = false;
                g.$set(g, 'stats', json.data);
            }).catch(function(err) {
                if (typeof err == 'undefined') {
                    return;
                }
                if (err.message == "Aborted") {
                    return;
                }
                g.loading = false;
                if (err.errors == "Page not found") {
                    g.showError("You don't appear to have any stats.");
                    return
                }
                g.showError(err.message);
            })
        },
        loadAgentStats(agentcode) {
            this.$router.push('/my_stats/agents/' + agentcode)
        }
    },
    watch: {
        'agent.AgentCode': function(newV) {
            this.stats = {
                "rollingCloseRatio6weeks": {},
                "rollingCloseRatioPrevious6weeks": {},
                "monthlyProduction": {},
                "monthlyProductionPrevious": {},
                "salesData": [],
            }
            this.$nextTick(this.loadData);
        },
    },
    components: {
        QProgressStat,
        QComparisonStat,
        QMonthlySalesChart,
        QPromotionTrackerChart,
        QTooltipDetails,
        QBusinessTimePeriodSelect,

        QStatsSubmittedChart,
        QStatsCloseRatioChart,
        QStatsPlacedChart,

        QStatsUniqueWritersChart
    }
}

</script>
<style>
.v-tour__target--highlighted.v-tour__target--relative {
    z-index: 1;
}

</style>
